import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';

import { Layout } from '../components/common';
import { MetaData } from '../components/common/meta';

/**
* Single page (/:slug)
*
* This file renders a single page and loads all the content.
*
*/
const Page = ({ data, location }) => {
	const page = data.ghostPage;
	const pageList = data.allGhostPage;

	return (
		<Fragment>
			<MetaData
				data={data}
				location={location}
				type="website"
			/>
			<Helmet>
				<style type="text/css">{`${page.codeinjection_styles}`}</style>
			</Helmet>
			<Layout>
				<div className="container">
					<article className="content">
						<section className="collection-content">
							<h1 className="content-title">{page.title}</h1>
							{pageList.edges.length > 0 &&
							<Fragment>
								<h2 className="collection-title">Collections</h2>
								<ul className="collection-list page-list">
									{ pageList.edges.map((node, i) => (
										<li key={`post-list ${i}`}>
											<a href={`${location.pathname.replace(/\/$/, ``)}/${node.node.slug}`}>{node.node.title}</a>
										</li>
									))
									}
								</ul>
							</Fragment>
							}
							{/* The main page content */}
							<section
								className="content-body load-external-scripts"
								dangerouslySetInnerHTML={{ __html: page.html }}
							/>
						</section>
					</article>
				</div>
			</Layout>
		</Fragment>
	);
};

Page.propTypes = {
	data: PropTypes.shape({
		allGhostPage: PropTypes.shape({
			edges: PropTypes.array,
		}),
		ghostPage: PropTypes.shape({
			codeinjection_styles: PropTypes.object,
			title: PropTypes.string.isRequired,
			html: PropTypes.string,
			slug: PropTypes.string,
			feature_image: PropTypes.string,
		}).isRequired,
	}).isRequired,
	location: PropTypes.object.isRequired,
};

export default Page;

export const postQuery = graphql`
    query($slug: String!) {
			ghostPage(slug: {eq: $slug}) {
				...GhostPageFields
			}
			allGhostPage(sort: {order: ASC, fields: published_at}, filter: {tags: {elemMatch: {slug: {eq: $slug}}}}) {
		    edges {
		      node {
		        slug
		        url
		        tags {
		          slug
		        }
		        primary_tag {
		          slug
		        }
						title
		      }
		    }
		  }
    }
`;
